import {useMutation} from 'react-query';
import postStoreOrder from './postStoreOrder';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const usePostStoreOrder = (
  handleAfterSuccess?: (data: ICreateOrderResponse) => void,
) => {
  const {isLoading, mutate, isSuccess} = useMutation<
    ICreateOrderResponse,
    AxiosError<IAxiosErr>,
    OrderPayload
  >({
    mutationFn: postStoreOrder,
    onSuccess: data => handleAfterSuccess?.(data),
    onError: error => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostStoreOrder;
